import React from 'react'
import ReactDOM from 'react-dom'
import 'bootstrap/dist/css/bootstrap.css'
import './index.css'
import App from './components/app'

ReactDOM.render(<App />, document.querySelector('#root'))
